import { UnknownObject } from '..';

export type EnvItemHost = {
  endpoint: string;
  headers: UnknownObject;
};

export type ItemHostConfig = {
  DEV: EnvItemHost;
  INTE?: EnvItemHost;
  QA: EnvItemHost;
  CERT?: EnvItemHost;
  FARM1?: EnvItemHost;
  FARM2?: EnvItemHost;
  PROD: EnvItemHost;
};

export enum ENV_NAME {
  PROD = 'prod',
  QA = 'qa',
  DEV = 'dev',
}

export type HostConfig = {
  name: ENV_NAME;
  host: string;
  custo?: EnvItemHost;
  catalogue?: EnvItemHost;
  telco?: EnvItemHost;
  legado?: EnvItemHost;
  legadoNoVCM?: EnvItemHost;
  bucket?: EnvItemHost;
  orion?: EnvItemHost;
  tges?: EnvItemHost;
  telcoFront?: EnvItemHost;
  security?: EnvItemHost;
  tecalis?: EnvItemHost;
};
